<template>
  <div :class="tone">
    <div class="flex items-center gap-1.5">
      <i
        v-if="status === 'error'"
        class="fas fa-exclamation-circle"
        aria-hidden="true"
        data-cy="map-imported-error-icon"
      />
      <span>{{ displayValue(row.preview?.imported) }}</span>
    </div>
    <div
      v-if="message"
      class="text-xs"
      :class="{ 'text-gray-500': status === 'ok' }"
      data-cy="map-imported-message"
    >
      {{ message }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

import { displayValue, type MapRow } from "./mapColumns";

const props = defineProps<{ row: MapRow }>();

const status = computed(() => props.row.preview?.status);
// An ok row's message is a note on how the value imports (e.g. "Imports as 3 line items").
const message = computed(() => props.row.preview?.message ?? null);
const tone = computed(() => {
  if (status.value === "error") return "text-red-600";
  if (status.value === "warning") return "text-amber-700";
  return "text-gray-900";
});
</script>
